import React from "react";
import styled from "styled-components";

import { AnimatedTab } from "components/ui/animated/AnimatedTab";

import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";
import { salesDashboardTabOptions } from "constants/businessDashboard";

const TabBar = styled.div`
  padding: 0 16px;
  border-bottom: 1px solid #d1d3d7;
`;

export const SalesDashboardTabs = () => {
  const { searchParams, updateUrlParams } = useUpdateUrlParams();
  const activeTab = searchParams.get("tab") || salesDashboardTabOptions[0].id;

  const handleTabChange = (newTab: string) => {
    updateUrlParams({ tab: newTab });
  };

  return (
    <TabBar>
      <AnimatedTab
        tabs={salesDashboardTabOptions}
        gap={0}
        minWidth={50}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </TabBar>
  );
};
